import Swiper from 'swiper';
import {Pagination, Navigation, Mousewheel} from 'swiper/modules';
import { mousewheel } from '@/scripts/core/global'

new Swiper('.targeted-series-slider', {
	slidesPerView: 1.4,
	modules: [Pagination, Navigation, Mousewheel],
	mousewheel,
	pagination: {
		clickable: true,
		el: '.targeted-series-slider .swiper-pagination',
	},
	navigation: {
		prevEl: '.targeted-series-slider .swiper-button-prev',
		nextEl: '.targeted-series-slider .swiper-button-next',
	},
	breakpoints: {
		768: {
			slidesPerView: 2.4,
		},
		1024: {
			slidesPerView: 4,
		},
	},
})